import { useState } from "react";

/**
 * True when this document is running inside a nested browsing context (iframe).
 */
export function isEmbeddedFrame() {
    if (typeof window === "undefined") {
        return false;
    }
    try {
        return window.self !== window.top;
    } catch {
        /* cross-origin edge cases since window.top errors*/
        return true;
    }
}

export function useEmbeddedView() {
    const [embedded] = useState(isEmbeddedFrame);
    return embedded;
}
